import React from 'react'

import { StaticQuery, graphql } from 'gatsby'
import { NonStretchedImage } from "actl"


export default function Image(){
    return (<StaticQuery
        query={graphql`
            query {
                img: file(relativePath: { eq: "jenkins_k8s.png" }) {
                    childImageSharp {
                        fluid(maxWidth: 400) {
                        ...GatsbyImageSharpFluid_tracedSVG
                        presentationWidth
                        }
                    }
                }
            }
        `}
        render= {data => <NonStretchedImage {...data.img.childImageSharp}/>}
    />)
}